<form class="g-3 needs-validation" novalidate [formGroup]="frmSaddlery" (ngSubmit)="onSubmit()">

  <!-- Cover Limit Section -->
  <div class="form_sections">
    <div class="col-md-6">
      <mat-form-field class="w-100">
        <mat-label>Cover Limit (per annum)</mat-label>
        <mat-select formControlName="sdtk_option_id" class="form-control form-control-sm" name="sdtk_option_id" required
          [ngClass]="{ 'is-invalid': (submitted) && frmSaddlery.get('sdtk_option_id').errors?.required }">
          <mat-option *ngFor="let opt of coverLimitOptions" [value]="opt.id">
            {{ opt.name }}
          </mat-option>
        </mat-select>
        <div class="invalid-feedback" *ngIf="(submitted) && frmSaddlery.get('sdtk_option_id').errors?.required">
          Please select a cover limit.
        </div>
      </mat-form-field>
    </div>
  </div>

  <!-- High Value Items Section -->
  <div class="green_border_panel mt-3">
    <div class="row">
      <div class="col-md-12">
        <h6 class="text-white">Do you have any items valued at £1500 or over?</h6>
        <mat-radio-group class="row" aria-label="Select an option" name="has_high_value_items"
          formControlName="has_high_value_items" required (change)="onHighValueChange($event)">
          <div class="col-md-4">
            <div class="quote_radio w-90">
              <mat-radio-button [value]="true">Yes</mat-radio-button>
            </div>
          </div>
          <div class="col-md-4">
            <div class="quote_radio w-90">
              <mat-radio-button [value]="false">No</mat-radio-button>
            </div>
          </div>
        </mat-radio-group>
        <div class="invalid-feedback" style="font-size: 13px;"
          *ngIf="(frmSaddlery.get('has_high_value_items').touched || submitted) && frmSaddlery.get('has_high_value_items').errors?.required">
          Please select an option.
        </div>
      </div>
    </div>

    <!-- High Value Items List -->
    <div class="text-white mt-3" *ngIf="frmSaddlery.get('has_high_value_items')?.value === true">
      <h6>Please provide details of each item and confirm the market value</h6>
      <small>Note that the total value of the specified items is included within the cover limit you have selected
        above, not in addition to it. Please amend your cover limit if necessary.</small>

      <div formArrayName="high_value_items" class="mt-3">
        <div *ngFor="let item of highValueItems.controls; let i = index" [formGroupName]="i" class="mb-4">
          <div class="row mb-2">
            <div class="col-md-12">
              <h6 class="text-white"><strong>Item {{i + 1}}</strong></h6>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-md-4">
              <label class="text-white">Make</label>
              <input (input)="capitalizeField($event, 'make', i)" type="text" class="form-control form-control-sm" placeholder="Enter make" formControlName="make"
                required
                [ngClass]="{ 'is-invalid': (item.get('make').touched || submitted) && item.get('make').errors?.required }">
              <div class="invalid-feedback"
                *ngIf="(item.get('make').touched || submitted) && item.get('make').errors?.required">
                Make is required.
              </div>
            </div>

            <div class="col-md-4">
              <label class="text-white">Model</label>
              <input (input)="capitalizeField($event, 'model', i)" type="text" class="form-control form-control-sm" placeholder="Enter model" formControlName="model"
                required
                [ngClass]="{ 'is-invalid': (item.get('model').touched || submitted) && item.get('model').errors?.required }">
              <div class="invalid-feedback"
                *ngIf="(item.get('model').touched || submitted) && item.get('model').errors?.required">
                Model is required.
              </div>
            </div>

            <div class="col-md-4">
              <label class="text-white">Type</label>
              <input (input)="capitalizeField($event, 'type', i)" type="text" class="form-control form-control-sm" placeholder="Enter type" formControlName="type"
                required
                [ngClass]="{ 'is-invalid': (item.get('type').touched || submitted) && item.get('type').errors?.required }">
              <div class="invalid-feedback"
                *ngIf="(item.get('type').touched || submitted) && item.get('type').errors?.required">
                Type is required.
              </div>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-md-4">
              <label class="text-white">Colour</label>
              <input (input)="capitalizeField($event, 'colour', i)" type="text" class="form-control form-control-sm" placeholder="Enter colour"
                formControlName="colour" required
                [ngClass]="{ 'is-invalid': (item.get('colour').touched || submitted) && item.get('colour').errors?.required }">
              <div class="invalid-feedback"
                *ngIf="(item.get('colour').touched || submitted) && item.get('colour').errors?.required">
                Colour is required.
              </div>
            </div>

            <div class="col-md-4">
              <label class="text-white">Size</label>
              <input (input)="capitalizeField($event, 'size', i)" type="text" class="form-control form-control-sm" placeholder="Enter size" formControlName="size"
                required
                [ngClass]="{ 'is-invalid': (item.get('size').touched || submitted) && item.get('size').errors?.required }">
              <div class="invalid-feedback"
                *ngIf="(item.get('size').touched || submitted) && item.get('size').errors?.required">
                Size is required.
              </div>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-md-4">
              <label class="text-white">Value</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text dark-green-bg text-white">&pound;</span>
                </div>
                <input (keydown)="blockDecimal($event)" type="number" class="form-control form-control-sm" placeholder="Enter value"
                  formControlName="value" required
                  [ngClass]="{ 'is-invalid': (item.get('value').touched || submitted) && (item.get('value').errors?.required || item.get('value').errors?.min) }">
                <div class="invalid-feedback"
                  *ngIf="(item.get('value').touched || submitted) && item.get('value').errors?.required">
                  Value is required.
                </div>
                <div class="invalid-feedback"
                  *ngIf="(item.get('value').touched || submitted) && item.get('value').errors?.min">
                  Value must be at least £1500.
                </div>
              </div>
            </div>

            <div class="col-md-2 d-flex align-items-end">
              <a (click)="removeItem(i)" class="btn btn-danger btn-sm p-1" *ngIf="highValueItems.controls.length > 1">
                <i class="mdi mdi-delete"></i> Remove
              </a>
            </div>
          </div>

          <hr class="bg-white" *ngIf="i < highValueItems.controls.length - 1">
        </div>
      </div>

      <!-- Total Value Warning -->
      <div class="alert alert-danger mt-2" *ngIf="isTotalOverLimit()">
        <strong>Warning:</strong> Total value of specified items (£{{totalHighValueItems}}) exceeds the selected cover
        limit (£{{coverLimitSelected}}). Please adjust your items or increase your cover limit.
      </div>

      <!-- Add Another Item Button -->
      <a (click)="addItem()" class="btn btn-default btn-success btn-sm f-12 mt-2">
        Click here if you wish to add another item
      </a>
    </div>
  </div>

  <!-- Legal Owner Section -->
  <div class="green_border_panel mt-3">
    <div class="row">
      <div class="col-md-12">
        <h6 class="text-white">Is the policyholder the legal owner of the saddlery and tack?</h6>
        <mat-radio-group class="row" aria-label="Select an option" name="is_legal_owner"
          formControlName="is_legal_owner" required>
          <div class="col-md-4">
            <div class="quote_radio w-90">
              <mat-radio-button [value]="true">Yes</mat-radio-button>
            </div>
          </div>
          <div class="col-md-4">
            <div class="quote_radio w-90">
              <mat-radio-button [value]="false">No</mat-radio-button>
            </div>
          </div>
        </mat-radio-group>
        <div class="invalid-feedback" style="font-size: 13px;"
          *ngIf="(frmSaddlery.get('is_legal_owner').touched || submitted) && frmSaddlery.get('is_legal_owner').errors?.required">
          Please select an option.
        </div>
      </div>
    </div>
  </div>

  <!-- Storage Location Section -->
  <div class="green_border_panel mt-3">
    <div class="row">
      <div class="col-md-6">
        <mat-form-field class="w-100">
          <mat-label>Where is the saddlery and tack usually stored?</mat-label>
          <mat-select formControlName="storage_location" class="form-control form-control-sm" name="storage_location"
            required
            [ngClass]="{ 'is-invalid': (frmSaddlery.get('storage_location').touched || submitted) && frmSaddlery.get('storage_location').errors?.required }">
            <mat-option *ngFor="let opt of storageOptions" [value]="opt.id">
              {{ opt.label }}
            </mat-option>
          </mat-select>
          <div class="invalid-feedback"
            *ngIf="(frmSaddlery.get('storage_location').touched || submitted) && frmSaddlery.get('storage_location').errors?.required">
            Please select an option.
          </div>
        </mat-form-field>
        <small class="text-white" *ngIf="frmSaddlery.get('storage_location').value === 'SHIPPING CONTAINER'">
          Note: A 10% loading will apply to your premium for shipping container storage.
        </small>
      </div>
    </div>
  </div>

  <!-- Agreement Statements Section -->
  <div class="green_border_panel mt-3">
    <h6 class="text-white mb-3">Please read and confirm your agreement to the following statements:</h6>

    <div class="row text-white">
      <div class="col-md-12 mb-3">
        <mat-checkbox formControlName="agree_security" name="agree_security" required
          [ngClass]="{ 'is-invalid': (submitted) && frmSaddlery.get('agree_security').errors?.required }">
          You acknowledge and agree to comply with the Motor Vehicle Security Requirements and the Building Security
          Requirements as detailed in Section 5 of the Policy Wording.
          <a class="ml-2" style="cursor: pointer;"
            (click)="helpTextPopup(content, '<strong>Motor Vehicle Security Requirement</strong> – where the saddlery and tack is kept in a motor vehicle or trailer that has been used with the vehicle, if the vehicle or trailer is unattended we will not accept any claim for theft unless:<br><br>a) The saddlery and tack has been concealed in a locked boot, cargo hold, or other locked internal compartment, and all of the vehicle\'s windows and doors have been closed, securely locked and the keys removed.<br>b) Any trailer must have a lockable hard top which is locked with the keys removed, and either has an anti-hitch enabled or a lockable wheel clamp applied.<br>c) Forcible and violent means have been used to gain access to the vehicle or trailer, evidence of which must be submitted with any claim together with the police crime reference number.<br><br>Failure to comply with this condition means we will not accept any claim for your saddlery and tack.<br><br><strong>Building Security Requirement</strong> – where the saddlery and tack is kept in a building, if the building is left unattended, we will not accept any claim for theft unless:<br><br>a) For a locked house, bungalow, flat or other residential building that you live in, all doors and windows have been locked.<br>b) For a locked building (other than a shipping container) or part of a building that you do not live in, the building or part of a building where the saddlery and tack is kept in must have a secure roof, all doors fitted with an integrated lock requiring insertion of a key or a key pad entry system, and all windows have steel bars or steel grids fitted.<br>c) For a shipping container, a container padlock is used to secure the unattended container.')">
            <u>Click here to view the security requirements</u>
          </a>
        </mat-checkbox>
        <div class="invalid-feedback" style="font-size: 13px;"
          *ngIf="(submitted) && frmSaddlery.get('agree_security').errors?.required">
          You must agree to this statement.
        </div>
      </div>

      <div class="col-md-12 mb-3">
        <mat-checkbox formControlName="agree_owner_payment" name="agree_owner_payment" required
          [ngClass]="{ 'is-invalid': (submitted) && frmSaddlery.get('agree_owner_payment').errors?.required }">
          You understand that if you are not the legal owner of the saddlery & tack then in the event of a claim we will
          require the owner's details and any settlement will be made to them.
        </mat-checkbox>
        <div class="invalid-feedback" style="font-size: 13px;"
          *ngIf="(submitted) && frmSaddlery.get('agree_owner_payment').errors?.required">
          You must agree to this statement.
        </div>
      </div>

      <div class="col-md-12 mb-3">
        <mat-checkbox formControlName="agree_no_riding_establishment" name="agree_no_riding_establishment" required
          [ngClass]="{ 'is-invalid': (submitted) && frmSaddlery.get('agree_no_riding_establishment').errors?.required }">
          You agree that the insured saddlery & tack is not used in connection with a riding establishment or the hiring
          out of a horse.
        </mat-checkbox>
        <div class="invalid-feedback" style="font-size: 13px;"
          *ngIf="(submitted) && frmSaddlery.get('agree_no_riding_establishment').errors?.required">
          You must agree to this statement.
        </div>
      </div>

      <div class="col-md-12 mb-3">
        <mat-checkbox formControlName="agree_under_insurance" name="agree_under_insurance" required
          [ngClass]="{ 'is-invalid': (submitted) && frmSaddlery.get('agree_under_insurance').errors?.required }">
          You acknowledge and understand the Under Insurance clause as detailed in Section 5 of the Policy Wording.
          <a class="ml-2" style="cursor: pointer;"
            (click)="helpTextPopup(content, '<strong>Under Insurance</strong> – if at the time of a valid claim the total value of your saddlery and tack is significantly (20% or more) valued more than the cover limit you chose, then we will only pay a percentage of any claim based on the amount of cover limit you have purchased compared to its real value. For example, if you chose a cover limit of £1000 and the value of the saddlery and tack was £2000, we would only pay 50% of any valid claim.')">
            <u>Click here to read the clause</u>
          </a>
        </mat-checkbox>
        <div class="invalid-feedback" style="font-size: 13px;"
          *ngIf="(submitted) && frmSaddlery.get('agree_under_insurance').errors?.required">
          You must agree to this statement.
        </div>
      </div>
    </div>
  </div>

  <!-- Submit Button -->
  <div class="row mt-4">
    <div class="col-md-12 text-right">
      <button type="submit" class="btn btn-success btn-sm">{{quote_type == 3 ? 'Proceed with MTA Changes':'Proceed'}}</button>
    </div>
  </div>

</form>

<!-- Help Text Modal -->
<ng-template #content let-modal>
  <div class="modal-body">
    <div class="helptext" [innerHTML]="helptext"></div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default btn-gray" (click)="modal.close()">Close</button>
  </div>
</ng-template>